export { default as Pagination } from "./pagination";
